import React from 'react';
import { PRODUCT_CATEGORY_SET, PRODUCT_USE_TYPE_SET } from 'enums/product.enum';
import Loading from 'components/_common/Loading';

const ProductUpdateV = ({ params, setParams, handleChange, isUpdate, submit, remove }) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <font>제품 관리</font>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{isUpdate ? '제품 수정' : '제품 등록'}</h3>

                            <div className="card-tools"></div>
                        </div>
                        <div className="g_update p-0 mt_30">
                            <table className="g_table table_type1">
                                <colgroup>
                                    <col width="20%" />
                                    <col width="80%" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            <label>제품코드 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'item.productCode', setParams, params)}
                                                    value={params.item.productCode || ''}
                                                    placeholder="제품코드를 입력해 주세요."
                                                    maxLength={20}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>제품명 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="text"
                                                    onChange={(e) => handleChange(e, 'item.productName', setParams, params)}
                                                    value={params.item.productName || ''}
                                                    placeholder="제품명을 입력해 주세요."
                                                    maxLength={100}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>카테고리 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <span className="g_select">
                                                    <select
                                                        className="form-control"
                                                        onChange={(e) => handleChange(e, 'item.category', setParams, params)}
                                                        value={params.item.category || ''}
                                                    >
                                                        <option value="">카테고리 선택</option>
                                                        {PRODUCT_CATEGORY_SET.map((category, index) => (
                                                            <option key={`category${index}`} value={category}>
                                                                {category === 'BOILER' ? '보일러' :
                                                                    category === 'PART' ? '부품' :
                                                                        category === 'HEAVY_PART' ? '중부품' : category}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>용도 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <span className="g_select">
                                                    <select
                                                        className="form-control"
                                                        onChange={(e) => handleChange(e, 'item.useType', setParams, params)}
                                                        value={params.item.useType || ''}
                                                    >
                                                        <option value="">용도 선택</option>
                                                        {PRODUCT_USE_TYPE_SET.map((useType, index) => (
                                                            <option key={`useType${index}`} value={useType}>
                                                                {useType === 'AS' ? 'A/S' :
                                                                    useType === 'SALE' ? '판매' : useType}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>판매가 <span className="required">*</span></label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="number"
                                                    onChange={(e) => handleChange(e, 'item.price', setParams, params)}
                                                    value={params.item.price || ''}
                                                    placeholder="판매가를 입력해 주세요."
                                                    min="0"
                                                    step="1000"
                                                />
                                                <small className="text-muted">원</small>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>원가</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <input
                                                    className="form-control input-sm"
                                                    type="number"
                                                    onChange={(e) => handleChange(e, 'item.costPrice', setParams, params)}
                                                    value={params.item.costPrice || ''}
                                                    placeholder="원가를 입력해 주세요. (선택사항)"
                                                    min="0"
                                                    step="1000"
                                                />
                                                <small className="text-muted">원 (선택사항)</small>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>
                                            <label>사용여부</label>
                                        </th>
                                        <td>
                                            <div className="inner">
                                                <div className="form-check checkbox-lg form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        onChange={(e) => handleChange(e, 'item.isActive', setParams, params)}
                                                        checked={params.item.isActive === true}
                                                        name="isActive"
                                                        id="isActiveY"
                                                        value="true"
                                                    />
                                                    <label className="form-check-label" htmlFor="isActiveY">
                                                        활성
                                                    </label>
                                                </div>
                                                <div className="form-check checkbox-lg form-check-inline">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        onChange={(e) => handleChange(e, 'item.isActive', setParams, params)}
                                                        checked={params.item.isActive === false}
                                                        name="isActive"
                                                        id="isActiveN"
                                                        value="false"
                                                    />
                                                    <label className="form-check-label" htmlFor="isActiveN">
                                                        비활성
                                                    </label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="card-footer">
                            <a
                                className="btn btn-success float-left"
                                onClick={() => {
                                    history.back();
                                }}
                            >
                                <i className="fas fa-long-arrow-left mr_10"></i>이전
                            </a>

                            <button type="button" onClick={submit} className="btn btn-primary float-right">
                                {isUpdate ? '수정' : '등록'}
                            </button>
                            {isUpdate && (
                                <button type="button" onClick={remove} className="btn btn-danger float-right mr_10">
                                    삭제
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default ProductUpdateV;